import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NotificationsCheckboxesComponent } from '@modules/notifications-checkboxes/notifications-checkboxes.component';
import { MbsUiKitModule } from 'mbs-ui-kit';

@NgModule({
  declarations: [NotificationsCheckboxesComponent],
  imports: [CommonModule, MbsUiKitModule, FormsModule],
  exports: [NotificationsCheckboxesComponent]
})
export class NotificationsCheckboxesModule {}
